// Casos (trabajos terminados) que se muestran en /casos/ y /casos/<slug>/.
// A estas fichas apuntan los codigos QR que van junto al sello del
// laboratorio en cada caja: QR general de la caja -> /casos/, QR de un
// trabajo concreto -> /casos/<slug>/. Ver build-src/qr/make-qr.js para
// generar la imagen del QR (con el logo incrustado) de cada uno.
//
// Para anadir un caso real:
//   1. Crea una carpeta assets/casos/<slug>/ (mismo <slug> que pongas abajo)
//      y mete ahi las fotos (.jpg/.png), el video (.mp4) y/o el modelo 3D
//      (.glb, y opcionalmente .usdz para que el AR funcione tambien en
//      iPhone) de ese trabajo. Ver assets/casos/README.md.
//   2. Copia uno de los bloques de CASES, cambia slug/titulo/textos y las
//      rutas de photos/video/arModel para que apunten a esa carpeta.
//   3. Quita "demo: true" (o borra la linea): eso es lo unico que decide si
//      el caso sale indexado en Google y en el sitemap, o si se queda solo
//      como ejemplo interno.
//   4. `npm run build` en WEB/ y sube el contenido de build-src/dist/ al
//      servidor, como con el resto del sitio.
//   5. Genera el QR de ese caso:
//      node build-src/qr/make-qr.js "https://dentalproject.io/casos/<slug>/" build-src/qr-out/qr-<slug>.png --label "Escanea para ver este caso"
module.exports.CASES = [
  {
    slug: "ejemplo-corona-zirconio",
    demo: true,
    title: "Rehabilitación Zr Monolítico",
    material: "Zirconio monolítico",
    tags: ["Zirconio", "Rehabilitación"],
    summary:
      "Ficha de ejemplo para probar el sistema de casos: así se verá un trabajo real cuando una clínica escanee el QR de la caja.",
    photos: [
      { src: "/assets/casos/ejemplo-corona-zirconio/foto-1.jpg", alt: "Rehabilitación en zirconio monolítico sobre modelo de trabajo" },
    ],
    video: null,
    arModel: null,
  },
  {
    slug: "prueba-test-pmma",
    demo: true,
    title: "Prueba Test PMMA",
    material: "PMMA · prueba de ajuste",
    tags: ["PMMA", "Provisional"],
    summary:
      "Ficha de ejemplo para probar el sistema de casos: así se verá un trabajo real cuando una clínica escanee el QR de la caja.",
    photos: [
      { src: "/assets/casos/prueba-test-pmma/foto-1.jpg", alt: "Prueba de ajuste en PMMA, puente completo atornillado" },
    ],
    video: null,
    arModel: null,
  },
];
